import React from "react";
import upload from "../../image/media/upload.png";
import whatsappimg from  "../../image/whatsapp.png";

const Whatsapp = ({path}) => {
  return (
    <a href={path} target="_blank" className="ph-whatsapp-icon">
      <div className="whatsapp">
        <img src={whatsappimg} width="30" height="30px" onError={(e) => {
          e.target.onerror = null; 
          e.target.src = upload; 
        }} alt="Whatsapp Icon"></img>
        <span className="ml-1 mr-1"> WhatsApp</span>
      </div>
    </a>
  );
}

export default Whatsapp;

